<div *ngFor="let question of selectedSampleQuestions" class="d-flex flex-wrap gap-3 mb-3">
  <div
    class="sample-question"
    role="button"
    tabindex="0"
    (click)="onQuestionClick(question)"
    (keydown.enter)="onQuestionClick(question)"
  >
    {{ question }}
  </div>
</div>
